export interface InvoiceTextField {
  key: string;
  label: string;
  default: string;
  multiline?: boolean;
  group: 'a4' | 'pos';
}

export const INVOICE_TEXT_FIELDS: InvoiceTextField[] = [
  // A4 Invoice
  { key: 'label_from', label: 'A4 — "From" Label', default: 'From', group: 'a4' },
  { key: 'label_bill_to', label: 'A4 — "Bill To" Label', default: 'Bill To', group: 'a4' },
  { key: 'label_issue_date', label: 'A4 — "Issue Date" Label', default: 'Issue Date', group: 'a4' },
  { key: 'label_payment_status', label: 'A4 — "Payment Status" Label', default: 'Payment Status', group: 'a4' },
  { key: 'label_sales_person', label: 'A4 — "Sales Person" Label', default: 'Sales Person', group: 'a4' },
  { key: 'label_sold_by', label: 'A4 — "Sold By" Label (reseller/mini-shop orders)', default: 'Sold By', group: 'a4' },
  { key: 'th_description', label: 'A4 Table — Description Header', default: 'Description', group: 'a4' },
  { key: 'th_qty', label: 'A4 Table — Qty Header', default: 'Qty', group: 'a4' },
  { key: 'th_unit_price', label: 'A4 Table — Unit Price Header', default: 'Unit Price', group: 'a4' },
  { key: 'th_amount', label: 'A4 Table — Amount Header', default: 'Amount', group: 'a4' },
  { key: 'empty_line_items', label: 'A4 — Empty Line Items Text', default: 'No line items', group: 'a4' },
  { key: 'label_serial', label: 'A4 — Serial Prefix', default: 'Serial:', group: 'a4' },
  { key: 'label_subtotal', label: 'A4 — "Subtotal" Label', default: 'Subtotal', group: 'a4' },
  { key: 'label_delivery_charge', label: 'A4 — "Delivery Charge" Label', default: 'Delivery Charge', group: 'a4' },
  { key: 'label_discount', label: 'A4 — "Discount" Label', default: 'Discount', group: 'a4' },
  { key: 'vat_note_with_amount', label: 'A4 — VAT Note, amount shown (use {rate})', default: 'Includes VAT ({rate}%)', group: 'a4' },
  { key: 'vat_note_rate_only', label: 'A4 — VAT Note, rate only (use {rate})', default: 'Prices include {rate}% VAT', group: 'a4' },
  { key: 'label_total', label: 'A4 — "Total" Label', default: 'Total', group: 'a4' },
  { key: 'label_payment_terms', label: 'A4 — "Payment Terms" Label', default: 'Payment Terms', group: 'a4' },
  { key: 'label_payment_method', label: 'A4 — "Payment Method" Label', default: 'Payment Method', group: 'a4' },
  { key: 'label_notes', label: 'A4 — "Notes" Label', default: 'Notes', group: 'a4' },
  { key: 'label_authorized_signature', label: 'A4 — "Authorized Signature" Caption', default: 'Authorized Signature', group: 'a4' },
  { key: 'label_scan_to_connect', label: 'A4 — "Scan to Connect" QR Caption', default: 'Scan to\nConnect', multiline: true, group: 'a4' },
  { key: 'thank_you_message', label: 'A4 — Thank You Message (use {brand})', default: 'Thank you for shopping with {brand}!', group: 'a4' },
  {
    key: 'no_signature_note',
    label: 'A4 — No-Signature Note',
    default: 'This is a system-generated invoice and does not require a signature.',
    multiline: true,
    group: 'a4',
  },
  { key: 'doc_label_invoice', label: 'A4 — Document Type Badge: Invoice', default: 'Invoice', group: 'a4' },
  { key: 'doc_label_proforma_invoice', label: 'A4 — Document Type Badge: Proforma Invoice', default: 'Proforma Invoice', group: 'a4' },
  { key: 'doc_label_purchase_order', label: 'A4 — Document Type Badge: Purchase Order', default: 'Purchase Order', group: 'a4' },
  { key: 'doc_label_receipt', label: 'A4 — Document Type Badge: Receipt', default: 'Receipt', group: 'a4' },

  // POS Receipt
  { key: 'pos_concern_prefix', label: 'POS — "A concern of" Prefix', default: 'A concern of', group: 'pos' },
  { key: 'pos_bin_prefix', label: 'POS — "BIN:" Prefix', default: 'BIN:', group: 'pos' },
  { key: 'pos_phone_prefix', label: 'POS — "Phone:" Prefix', default: 'Phone:', group: 'pos' },
  { key: 'pos_label_receipt_no', label: 'POS — "Receipt No" Label', default: 'Receipt No', group: 'pos' },
  { key: 'pos_label_date', label: 'POS — "Date" Label', default: 'Date', group: 'pos' },
  { key: 'pos_label_customer', label: 'POS — "Customer" Label', default: 'Customer', group: 'pos' },
  { key: 'pos_label_customer_phone', label: 'POS — "Customer Phone" Label', default: 'Customer Phone', group: 'pos' },
  { key: 'pos_label_sales_person', label: 'POS — "Sales Person" Label', default: 'Sales Person', group: 'pos' },
  { key: 'pos_empty_line_items', label: 'POS — Empty Line Items Text', default: 'No line items', group: 'pos' },
  { key: 'pos_label_subtotal', label: 'POS — "Subtotal" Label', default: 'Subtotal', group: 'pos' },
  { key: 'pos_label_delivery_charge', label: 'POS — "Delivery Charge" Label', default: 'Delivery Charge', group: 'pos' },
  { key: 'pos_label_discount', label: 'POS — "Discount" Label', default: 'Discount', group: 'pos' },
  { key: 'pos_vat_note_with_amount', label: 'POS — VAT Note, amount shown (use {rate})', default: 'Includes VAT ({rate}%)', group: 'pos' },
  { key: 'pos_vat_note_rate_only', label: 'POS — VAT Note, rate only (use {rate})', default: 'Prices include {rate}% VAT', group: 'pos' },
  { key: 'pos_label_total', label: 'POS — "TOTAL" Label (use {currency})', default: 'TOTAL ({currency})', group: 'pos' },
  { key: 'pos_label_payment_method', label: 'POS — "Payment Method" Label', default: 'Payment Method', group: 'pos' },
  { key: 'pos_label_payment_status', label: 'POS — "Payment Status" Label', default: 'Payment Status', group: 'pos' },
  { key: 'pos_thank_you', label: 'POS — Thank You Message (use {brand})', default: 'Thank you for shopping with {brand}!', group: 'pos' },
  { key: 'pos_visit_now', label: 'POS — "Visit Now:" Prefix', default: 'Visit Now:', group: 'pos' },
];

export function invoiceText(overrides: Record<string, string> | null | undefined, key: string, vars?: Record<string, string | number>): string {
  const override = overrides?.[key]?.trim();
  const base = override || INVOICE_TEXT_FIELDS.find((f) => f.key === key)?.default || '';
  if (!vars) return base;
  return Object.entries(vars).reduce((s, [k, v]) => s.split(`{${k}}`).join(String(v)), base);
}
